import axios from "axios";
import Cookies from "js-cookie";
import makeApiCall from "../master/axiosIndex";

const STATIC_FILES_DATA = {
  docKeys: [
    {
      order: 0,
      module: "Material Issue",
      moduleFileType: "signature.png",
    },
  ],
};

const inventoryCreation = {
  fetchSiteInventory: (
    sortOrder: any,
    pageSize: any,
    direction: any,
    pageDiff: any,
    paginationId: any,
    siteId: any,
    categoryId: any
  ): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/siteInventory/list",
      params: {
        sortOrder,
        pageSize,
        direction,
        pageDiff,
        paginationId,
        siteId,
        categoryId,
      },
    }),
  fetchSiteInventoryPagiantion: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/inventory/siteInventory/list",
      method: "get",
      params,
    }),
  fetchMaterialIssue: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/materialIssue/list",
      params,
    }),
  fetchPendingApprovals: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/materialIssue/pendingApprovals",
      params,
    }),
  createSiteIssue: (data: any): Promise<any> =>
    makeApiCall<any>({
      method: "post",
      url: "/inventory/materialIssue/new",
      data,
    }),
  fetchTasksByMaterial: async (params: {
    siteId: any;
    materialId: any;
    contractorId: any;
  }): Promise<any> => {
    // Lives on the max-infra service, not the default gateway. Uses raw axios
    // (not the shared instance) so a 401/CORS failure here doesn't trip the
    // global response interceptor and bounce the user to the login page.
    const accessToken = Cookies.get("access-token");
    try {
      const res = await axios.get(
        "https://dev-maxinfra-api.procurex.app/gateWay/task/tasksByMaterial",
        {
          params,
          headers: accessToken ? { Authorization: `${accessToken}` } : {},
          withCredentials: false,
        }
      );
      return res.data;
    } catch (error: any) {
      console.log("fetchTasksByMaterial error:", error);
      return error?.response?.data ?? { status: false, data: [] };
    }
  },
  createSiteIssueDemo: (data: any): Promise<any> => {
    console.log("[DEMO] createSiteIssueDemo payload:", data);
    return Promise.resolve({
      status: true,
      message: "Material Issue created (demo)",
      response: { id: 0 },
    });
  },
  // Returns the available issue-task allocations for a given issue line.
  // Each item is a reference to an `issueTaskId` plus a display label.
  // The handover screen uses these as the picker options when splitting the
  // handover qty across the issue's tasks. Stubbed until the real endpoint
  // (e.g. /inventory/materialIssue/line/:issueLineId/tasks) is exposed.
  fetchIssueLineTasksDemo: (_issueLineId: any): Promise<any> =>
    Promise.resolve({
      status: true,
      data: [
        { issueTaskId: 1, taskName: "Excavation - Block A", boqName: "BOQ A" },
        { issueTaskId: 2, taskName: "PCC - Block A", boqName: "BOQ A" },
        { issueTaskId: 3, taskName: "Footing - Block B", boqName: "BOQ B" },
      ],
    }),
  // Returns the available handover-task allocations for a given handover line.
  // Used by the utilization screen as the picker options when splitting
  // utilized / return / damaged qtys across handover tasks. Stubbed until the
  // real endpoint (e.g. /inventory/materialIssue/handoverLine/:id/tasks) is
  // exposed by the backend.
  fetchHandoverLineTasksDemo: (_handoverLineId: any): Promise<any> =>
    Promise.resolve({
      status: true,
      data: [
        { handoverTaskId: 1, taskName: "Excavation - Block A", boqName: "BOQ A" },
        { handoverTaskId: 2, taskName: "PCC - Block A", boqName: "BOQ A" },
        { handoverTaskId: 3, taskName: "Footing - Block B", boqName: "BOQ B" },
      ],
    }),
  fetchViewMaterialDetails: (id: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/inventory/materialIssue/id/${id}`,
      // params:id
    }),

  approve: (materialIssueId: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      materialIssueId,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/inventory/materialIssue/approve`,
      data: formData,
    });
  },

  reject: (materialIssueId: number, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      materialIssueId,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "put",
      url: `/inventory/materialIssue/reject`,
      data: formData,
    });
  },

  fetchMaterialStock: (siteId: number, materialId: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/materialStock",
      params: {
        siteId,
        materialId,
      },
    }),
  fetchMaterialPendingHandOver: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/materialIssue/readyToHandoverPendingList",
      params,
    }),
  fetchMaterialHandOver: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/handoverPaginationList",
      params,
    }),
  fetchMaterialUtilization: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: "/inventory/pendingUtilizationList",
      params,
    }),
  fetchHandOverById: (handoverId: number): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/inventory/getOneHandover/${handoverId}`,
    }),
  updateHandoverQuantities: (formData: FormData): Promise<any> => {
    return makeApiCall<any>({
      method: "put",
      url: "/inventory/materialIssue/handover",
      data: formData,
    });
  },
  updateUtilizeQuantities: (formData: FormData): Promise<any> => {
    return makeApiCall<any>({
      method: "post",
      url: "/inventory/updateUtilization",
      data: formData,
    });
  },
};

export default inventoryCreation;
